import ROLE from "enums/ROLE_NAME";
import useCurrentUser from "hooks/useCurrentUser";

interface Props {
  children: React.ReactNode;
  disallowedRoles?: ROLE[];
  allowedRoles?: ROLE[];
}

export default function RoleGuard({
  children,
  disallowedRoles = [],
  allowedRoles = [],
}: Props) {
  const { role } = useCurrentUser();

  if (disallowedRoles.length > 0 && disallowedRoles.includes(role))
    return undefined;

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) return undefined;

  return children;
}
